import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { config } from './config';
import languageMap from '../languageMap';
import './guestsDetails.css'; // Import CSS file for styling

const GuestsDetails = () => {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showGuests, setShowGuests] = useState(false);
  const selectedLanguage = languageMap.config.selectedLanguage || 'en';
  const location = useLocation();

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const username = searchParams.get('username');
        const event_name = searchParams.get('event_name');

        const response = await axios.get(`${config.apiUrl}/get_all_events_guest_names/${username}/${event_name}`);
        setGuests(response.data.guest_names);
        setLoading(false);
        setShowGuests(true);
      } catch (error) {
        console.error('Error fetching guests:', error);
        setError(languageMap.errorFetchingGuests[selectedLanguage] || 'Error fetching guests');
        setLoading(false);
        setShowGuests(false);
      }
    };

    fetchGuests();
  }, [location.search, selectedLanguage]);

  return (
    <div className="GuestsDetailsContainer">
      <h2 className="guestsTitle">{languageMap.guestsDetailsTitle[selectedLanguage]}</h2>
      {loading && <p className="loadingMessage">Loading guests...</p>}
      {error && <p className="errorMessage">{error}</p>}
      {showGuests && (
        <ul className="guestsList">
          {guests.map((guest, index) => (
            <li key={index} className="guestItem">{guest}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default GuestsDetails;
